import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

const initialState = {
    status: null,
    message: null,
    data: null,
    configId: null,
    targetStoreHash: null
}


export const saveProductMapping = createAsyncThunk("saveProductMapping", async (mappingData) => {
    try {
        const response = await fetch(`/api/saveMapping`, {
            method: 'POST',
            headers: {
                Accept: "application/json",
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(mappingData)
        })
        if (!response.ok) {
            throw new Error('Failed to save the mapping');
        }
        return await response.json();
    } catch (error) {
        throw new Error('Failed to save the mapping', error);
    }
});

const credentialsSlice = createSlice({
    name: "saveProductMapping",
    initialState,
    extraReducers: (builder) => {
        builder.addCase(saveProductMapping.pending, (state) => {
            state.status = "Loading"
        });
        builder.addCase(saveProductMapping.fulfilled, (state, action) => {
            state.targetStoreHash = action.payload.data.data.targetClientDomain
            state.status = "success"
            state.message = "Attribute mapping saved successfully"
            state.data = action.payload.data.data
            state.configId = action.payload.data.data.struConfigId
        });
        builder.addCase(saveProductMapping.rejected, (state) => {
            state.status = "error"
            state.message = "Attribute mapping failed save"
        });
    }
})

export default credentialsSlice.reducer